import axios from "axios"
import { URI_LOCAL } from "../data/constants"
import { IScenarioComparision, ISimulationComparision } from "../models/ScenarioModel"

export const getSimulationComparision = (body:ISimulationComparision) => {
    const response = axios.post(`${URI_LOCAL}Scenario_simulated_info/get_scenario_simulation_comparision`, body)
    return response
}

export const getSimulationComparisionByTabID = (body:ISimulationComparision) => {
    const response = axios.post(`${URI_LOCAL}Scenario_simulated_info/get_scenario_simulation_comparision`, body)
    return response
}

export const getScenarioComparision = (body:IScenarioComparision) => {
    const response = axios.post(`${URI_LOCAL}Scenario_info/get_scenario_comparision`, body)
    return response
}

export const getScenarioComparisionByTabID = (body:IScenarioComparision) => {
    const response = axios.post(`${URI_LOCAL}Scenario_info/get_scenario_comparision`, body)
    return response
}

export const getOperativeScenario = (id:number) => {
    const response = axios.get(`${URI_LOCAL}Operativo/get_operative_scenario/${id}`)
    return response
}

export const getOperativeScenarioByTabID = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Operativo/get_operative_scenario`,body)
    return response
}

export const updateOperativeScenario = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Operativo/update_operative_scenario`,body)
    return response
}

export const setReferenceSimulation = (id:number,body:any) => {
    const response = axios.put(`${URI_LOCAL}Operativo/change_reference_simulation/${id}`, body)
    return response
}

export const getComentariosByScenarioID = (id:number) => {
    const response = axios.get(`${URI_LOCAL}Comentarios/get_all_comentarios_by_scenario/${id}`)
    return response
}

export const addComentario = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Comentarios/add_comentario`, body)
    return response
}

export const deleteComentarioByID = (id:number) => {
    const response = axios.delete(`${URI_LOCAL}Comentarios/delete_comentario/${id}`)
    return response
}

export const editComentario = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Comentarios/edit_comentario/`, body)
    return response
}

export const deleteScenarioByID = (id:number) => {
    const response = axios.put(`${URI_LOCAL}Scenario_info/delete_scenario_by_id/${id}`)
    return response
}

export const deleteOperativeScenarioByID = (id:number) => {
    const response = axios.put(`${URI_LOCAL}Scenario_info/delete_operative/${id}`)
    return response
}

export const changeScenarioName = (body:any) => {
    const response = axios.put(`${URI_LOCAL}Scenario_info/change_scenario_name`, body)
    return response
}

export const getFilterOptionsByScenarioID = (id:number,id_compare:number) => {
    const response = axios.get(`${URI_LOCAL}Scenario_info/get_filter_options/${id}/${id_compare}`)
    return response
}

export const createNewScenario = (id:string,operativo:boolean) => {
    const response = axios.post(`${URI_LOCAL}Scenario_info/create_new_scenario`,{id_scenario_base: id,operativo:operativo})
    return response
}

export const updateScenario = (body:any) => {
    const response = axios.put(`${URI_LOCAL}Scenario_info/update_scenario`, body)
    return response   
}

export const queuedSimulations= () => {
    const response = axios.get(`${URI_LOCAL}Throw_simulation/queued_sims`)
    return response
}

export const launchSimulation = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Throw_simulation/`, body)
    return response
}

export const setPlantShutdown = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Operativo/plant_shutdown`, body)
    return response
}

export const setStockPilingShutdown = (body:any) => {
    const response = axios.post(`${URI_LOCAL}Operativo/stockpiling_shutdown`, body)
    return response
}